export default "__VITE_ASSET__B9VNqM3d__"